import { apiService } from './api';

export interface ArchiveSummary {
  steps_completed: number;
  completed_step_numbers: number[];
  has_getting_started: boolean;
  has_inventories: boolean;
  inventory_count: number;
}

export interface ProgressArchiveListItem {
  archive_id: string;
  archive_name: string;
  created_at: string;
  summary: ArchiveSummary;
  is_auto_archive: boolean;
}

export interface ProgressArchiveDetail extends ProgressArchiveListItem {
  snapshot: Record<string, unknown>;
}

export class ProgressArchiveService {
  static async listArchives(program = 'SAA', track = '12-steps'): Promise<{
    archives: ProgressArchiveListItem[];
    count: number;
    max: number;
    max_with_auto: number;
  }> {
    return apiService.listProgressArchives(program, track);
  }

  static async createArchive(options: {
    archive_name: string;
    clear_active?: boolean;
    is_auto_archive?: boolean;
    program?: string;
    track?: string;
  }): Promise<{
    archive_id: string;
    archive_name: string;
    created_at: string;
    summary: ArchiveSummary;
    cleared: boolean;
  }> {
    return apiService.createProgressArchive(options);
  }

  static async getArchive(archiveId: string, program = 'SAA', track = '12-steps'): Promise<ProgressArchiveDetail> {
    return apiService.getProgressArchive(archiveId, program, track);
  }

  static async restoreArchive(archiveId: string, program = 'SAA', track = '12-steps'): Promise<{ message: string }> {
    return apiService.restoreProgressArchive(archiveId, program, track);
  }

  static async deleteArchive(archiveId: string, program = 'SAA', track = '12-steps'): Promise<void> {
    return apiService.deleteProgressArchive(archiveId, program, track);
  }

  static formatSummary(summary?: ArchiveSummary | null): string {
    if (!summary) return 'Step work snapshot';
    const parts: string[] = [];
    if (summary.has_getting_started) {
      parts.push('Getting Started');
    }
    if (summary.steps_completed > 0) {
      parts.push(`${summary.steps_completed} step${summary.steps_completed === 1 ? '' : 's'} completed`);
    }
    if (summary.has_inventories) {
      parts.push('inventories saved');
    }
    return parts.length > 0 ? parts.join(' · ') : 'Step work snapshot';
  }

  static formatDate(iso: string): string {
    try {
      return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch {
      return iso;
    }
  }
}
